exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dialog-footer[data-v-f1f6c8b0] {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    margin-top: 30px;\n}\n.jumpUrlCss[data-v-f1f6c8b0] .el-form-item__label:before {\r\n    content: '*';\r\n    color: #f56c6c;\r\n    margin-right: 4px;\n}\r\n\r\n\r\n \r\n", ""]);

// exports
